import { PartnersPageDataService } from 'types/services';
import { m8API } from 'services/production/m8';
import { normalizePartnersPageDataServiceParams } from 'services/production/utils/normalizePartnersPageDataServiceParams';
import { normalizeM8PartnerDTO } from 'services/production/utils/normalizeM8PartnerDTO';

export const getPartnersPageData: PartnersPageDataService = async (params) => {
  const data = await m8API.admin.getPartnersPage(
    normalizePartnersPageDataServiceParams(params).toM8GetPartnersPageParams()
  );

  return {
    totalPagesCount: data.totalPages,
    partners: data.content.map((item) =>
      normalizeM8PartnerDTO(item).toPartnersTableItem()
    ),
  };
};
